/**
 * DeliverFresh Recently Viewed Module
 * Tracks product views in localStorage and renders them on the recently-viewed page.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'df_recently_viewed';
  var MAX_ITEMS = 20;

  /* ── Helpers ── */

  function getRecentlyViewed() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function trackProductView(handle) {
    if (!handle) return;
    var rv = getRecentlyViewed();
    // Remove duplicates
    rv = rv.filter(function (h) {
      return h !== handle;
    });
    // Add to front
    rv.unshift(handle);
    // Enforce limit
    if (rv.length > MAX_ITEMS) rv = rv.slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(rv));
  }

  /* ── Render recently viewed page ── */

  function renderRecentlyViewedPage() {
    var container = document.getElementById('df-recently-viewed-grid');
    var emptyState = document.getElementById('df-recently-viewed-empty');
    if (!container) return; // not on the recently-viewed page

    var handles = getRecentlyViewed();

    if (handles.length === 0) {
      container.style.display = 'none';
      if (emptyState) emptyState.style.display = 'block';
      return;
    }

    if (emptyState) emptyState.style.display = 'none';
    container.style.display = 'grid';
    container.innerHTML = '<div class="df-rv-loading">Loading recently viewed products...</div>';

    var fetches = handles.map(function (handle) {
      return fetch('/products/' + handle + '.json')
        .then(function (res) {
          if (!res.ok) throw new Error('Not found');
          return res.json();
        })
        .then(function (data) {
          return data.product;
        })
        .catch(function () {
          return null;
        });
    });

    Promise.all(fetches).then(function (products) {
      products = products.filter(Boolean);
      if (products.length === 0) {
        container.style.display = 'none';
        if (emptyState) emptyState.style.display = 'block';
        return;
      }

      container.innerHTML = '';
      products.forEach(function (product) {
        var variant = product.variants[0];
        var imgSrc = product.image
          ? product.image.src
          : '';
        var price = (variant.price / 1).toLocaleString('en-AU', {
          style: 'currency',
          currency: 'AUD',
        });

        var card = document.createElement('div');
        card.className = 'df-rv-card';
        card.innerHTML =
          '<a href="/products/' + product.handle + '" class="df-rv-card-img">' +
            (imgSrc
              ? '<img src="' + imgSrc + '" alt="' + product.title + '" loading="lazy">'
              : '<div class="df-rv-no-img">No image</div>') +
          '</a>' +
          '<div class="df-rv-card-body">' +
            '<a href="/products/' + product.handle + '" class="df-rv-card-title">' + product.title + '</a>' +
            '<div class="df-rv-card-price">' + price + '</div>' +
            '<form method="post" action="/cart/add">' +
              '<input type="hidden" name="id" value="' + variant.id + '">' +
              '<input type="hidden" name="quantity" value="1">' +
              '<button type="submit" class="df-rv-atc-btn">Add to Cart</button>' +
            '</form>' +
          '</div>';

        container.appendChild(card);
      });
    });
  }

  /* ── Init ── */

  document.addEventListener('DOMContentLoaded', function () {
    renderRecentlyViewedPage();
  });

  /* ── Expose globally ── */
  window.dfRecentlyViewed = {
    track: trackProductView,
    get: getRecentlyViewed,
  };
})();
